export const passwordValidation = `New password must be at least 8 characters and contain 1
  lowercase, 1 uppercase, and 1 number.`;

export const regexPasswordMatch = (value: string | null | undefined) => {
  const match = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(value as string);
  const validPass = match ? match && (value as string).length >= 8 : false;
  return validPass;
};
